import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[repeat]',
    standalone: false
})

export class RepeatDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) { }

  @Input() set repeat(loops: number) {
    this.viewContainerRef.clear();
    for (let index = 0; index < loops; index++) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
